// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"258":"26ce680d1cbfe2118810","675":"d26d47173837e4394f50"}[chunkId] + ".bundle.js";
};